"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AusStatesDropdown = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _Dropdown = require("../Dropdown");
var _propTypes = require("../../../../../propTypes");
var _utilities = require("../../../../../utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable camelcase */
const AusStatesDropdown = props => {
  return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, _extends({
    options: _utilities.AUS_States,
    name: "ausStates"
  }, props));
};
exports.AusStatesDropdown = AusStatesDropdown;
AusStatesDropdown.propTypes = _propTypes.DropdownPropTypes;
var _default = exports.default = {
  AusStatesDropdown
};